import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SwitchListItem from '../../../../../../list-items/SwitchListItem/SwitchListItem';


const VisualizerSpinLockLogoListItem = ({ logoLocked, updateVisualizerSettings }) => {
    const onStateChange = (event) => {
        updateVisualizerSettings({
            spinSettings: { logoLocked: event.target.checked },
            logoVisible: true
        });
    };

    return (
        <SwitchListItem
            text='Lock Logo'
            checked={logoLocked}
            onChange={(e)=> onStateChange(e)}
        />
    );
};

const mapStateToProps = (state) => {
    const { logoLocked } = state.createPreview.present.videoSettings.visualizer.spinSettings;
    return { logoLocked };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerSpinLockLogoListItem);